import type { Maybe } from '@adornis/base/utilTypes.js';
import { Int } from '@adornis/baseql/baseqlTypes.js';
import { Arg, Entity, Field, Mutation } from '@adornis/baseql/decorators.js';
import type { PartialEntityData } from '@adornis/baseql/entities/types.js';
import { validate } from '@adornis/validation/decorators.js';
import { nonOptional } from '@adornis/validation/functions/nonOptional.js';
import { ChancenEventlog } from './ChancenEventlog.js';

@Entity()
export class AnmeldungConversionEventlog extends ChancenEventlog {
  static override _class = 'AnmeldungConversionEventlog';

  constructor(doc: PartialEntityData<AnmeldungConversionEventlog>) {
    super(doc);
  }

  @validate(nonOptional())
  @Field(type => String)
  type: Maybe<'us' | 'os'>;

  @validate(nonOptional())
  @Field(type => Int)
  step: Maybe<number>;

  @Field(type => String)
  context: Maybe<string>;

  @validate(nonOptional({ allowFalsy: true }))
  @Field(type => Boolean)
  finished: Maybe<boolean>;

  @Mutation(type => Boolean)
  public static createOrUpdateAnmeldungConversionEventlog(
    @Arg('id', type => String) id: string,
    @Arg('type', type => String) type: 'us' | 'os',
    @Arg('step', type => Int) step: number,
    @Arg('finished', type => Boolean) finished: boolean,
    @Arg('context', type => String) context: string = '',
  ) {
    return async () => {
      const existing = await AnmeldungConversionEventlog.getByID<AnmeldungConversionEventlog>(id)({ _id: 1 });

      const log = new AnmeldungConversionEventlog({
        _id: id,
        type,
        step,
        finished,
        context,
        createdAt: new Date(),
      });

      if (existing) {
        await log.save();
      } else {
        await log.create();
      }

      return true;
    };
  }
}
